import React from "react";
import { IconButton } from "@mui/joy";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { useSavedListStore } from "../store/savedListStore";

interface SaveListButtonProps {
  listId: string;
  size?: "sm" | "md";
}

export const SaveListButton = ({
  listId,
  size = "sm",
}: SaveListButtonProps) => {
  const { isListSaved, saveList, unsaveList } = useSavedListStore();
  const [saving, setSaving] = React.useState(false);
  const saved = isListSaved(listId);

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setSaving(true);
    try {
      if (saved) {
        await unsaveList(listId);
      } else {
        await saveList(listId);
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <IconButton
      size={size}
      variant="plain"
      color={saved ? "primary" : "neutral"}
      onClick={handleClick}
      disabled={saving}
      aria-label={saved ? "Unsave list" : "Save list"}
      sx={{ "&:hover": { color: "primary.500" } }}
    >
      {saved ? (
        <BookmarkIcon fontSize="small" />
      ) : (
        <BookmarkBorderIcon fontSize="small" />
      )}
    </IconButton>
  );
};
